<script setup>
import { computed } from "vue";
import { getStatusColor } from "@/shared/config/statusDictionary";

const props = defineProps({
  code: { type: String, default: "" },
  size: { type: Number, default: 8 },
});

const style = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  backgroundColor: getStatusColor(props.code),
}));
</script>

<template>
  <span
    class="inline-block rounded-full shrink-0"
    :style="style"
    aria-hidden="true"
  />
</template>
